import { type JSX } from 'react';

import { passwortWechseln } from '../api/anmeldung';
import { Kennwortformular } from './Kennwortformular';

/**
 * Der erzwungene Passwortwechsel (BEN-06) — nach der ersten Anmeldung, nach
 * einem Zurücksetzen und seit AeA-48 nach dem Ablauf des Kennworts.
 *
 * Bis er erledigt ist, weist der Guard jeden anderen Endpunkt ab. Die
 * Oberflaeche bildet das ab, statt es zu umgehen: Es gibt hier keinen Weg
 * weiter ausser dem Wechsel und dem Abmelden.
 *
 * Die Felder teilt er mit „Mein Konto“ (Kennwortformular.tsx, AeA-48).
 */
export function Passwortwechsel({
  anmeldename,
  beiFertig,
  beiAbmelden,
  titelVerweis,
}: {
  readonly anmeldename: string;
  readonly beiFertig: () => void;
  readonly beiAbmelden: () => void;
  readonly titelVerweis?: React.Ref<HTMLHeadingElement>;
}): JSX.Element {
  return (
    <main className="maske" aria-labelledby="wechsel-titel">
      <h1 id="wechsel-titel" tabIndex={-1} ref={titelVerweis}>
        Passwort vergeben
      </h1>
      <p className="maske__unterzeile">
        Für <strong>{anmeldename}</strong>. Ein Kennwort, das Ihnen genannt wurde, gilt
        nur für diese erste Anmeldung; ein abgelaufenes Kennwort ersetzen Sie hier durch
        ein neues.
      </p>

      <Kennwortformular
        senden={passwortWechseln}
        beiFertig={beiFertig}
        knopf="Passwort speichern"
        hilfeAltes="Das Kennwort, mit dem Sie sich eben angemeldet haben."
        naechsterSchrittAltes="Geben Sie das Kennwort ein, mit dem Sie sich eben angemeldet haben."
        daneben={
          <button className="knopf" type="button" onClick={beiAbmelden}>
            Abmelden
          </button>
        }
      />

      <p className="warnung" role="note">
        Nach dem Wechsel werden <strong>alle</strong> Sitzungen dieses Kontos beendet,
        auch diese. Sie melden sich anschließend mit dem neuen Passwort neu an.
      </p>
    </main>
  );
}
